import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Role} from "../models/role";
import {MatTooltip} from "@angular/material/tooltip";
import {ActivatedRoute, Event, NavigationEnd, Router} from "@angular/router";
import {NavBarComponent} from "../nav-bar/nav-bar.component";
import { FeatureFlagsService } from '../unleash-feature-flags/feature-flags.service';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.css'],
    standalone: false
})
export class SideNavComponent implements OnInit {
  @Input() sideBarOpened: boolean = false;
  @Input() roles!: Role[];
  @Output() sideBarClose: EventEmitter<any> = new EventEmitter();
  @Output() redirect = new EventEmitter<string>();

  sideNavElements = [
    {
      section: 'Mapping',
      icon: 'map',
      label: 'MAP-ANALYSIS',
      roles: ['AngularMapping'],
      route: '/mapping',
      relatedRoutes: ['field', 'mapping'],
      featureFlag: 'map_analysis'
    },
    // TODO: Re-enable Maps nav item — may be hidden via a role/feature flag in future
    {
      icon: 'explore',
      label: 'MAPS',
      roles: ['AngularMaps'],
      route: '/maps',
      relatedRoutes: ['maps'],
      featureFlag: true,
      isNew: true
    },
    // {
    //   icon: 'article',
    //   label: 'FIELD-ADMIN',
    //   roles: ['AngularFieldAdmin'],
    //   route: '/field-admin/fields',
    //   relatedRoutes: ['field-admin', 'season'],
    // },
    {
      section: 'Management',
      icon: 'article',
      label: 'SEASON-MANAGER',
      roles: ['AngularFieldAdmin'],
      route: '/season-manager/seasons',
      relatedRoutes: ['season-manager', 'season'],
      featureFlag: 'season_manager'
    },
    {
      icon: 'format_line_spacing',
      label: 'PRIORITY-GROUPS',
      roles: ['AngularPriorityGroups'],
      route: '/priority-groups',
      relatedRoutes: ['priority-groups'],
      featureFlag: 'priority_groups'
    },
    {
      icon: 'location_on',
      label: 'PIN-MANAGER',
      roles: [],
      route: '/pin-manager/all-pins',
      relatedRoutes: ['pin-manager', 'all-samples'],
      featureFlag: 'pin_manager'
    },
    {
      icon: 'forum',
      label: 'VIRTUAL-CONSULTANT',
      roles: ['AngularVirtualConsultant'],
      route: '/virtual-consultant',
      relatedRoutes: ['virtual-consultant'],
      featureFlag: 'virtual_consultant'
    },
    // {
    //   icon: 'calendar_today',
    //   label: 'PRODUCTION-CALENDAR',
    //   roles: 'AngularProductionCalendar',
    //   route: '',
    //   redirect: 'prod_cal'
    // },
    {
      section: 'Insights',
      icon: 'assistant',
      label: 'RECOMMENDATIONS',
      roles: ['AngularRecommendations'],
      route: '',
      redirect: 'recommendations',
      isButton: true,
      featureFlag: 'recomendations_pg_feature'
    },
    {
      icon: 'assignment',
      route: '/order-manager/my-orders',
      label: 'ORDER-MANAGER',
      roles: ['OTCOverallApprovingManager', 'OTCApprovingManager', 'OTCAgent','OTCRepresentative'],
      relatedRoutes: ['order-manager'],
      featureFlag: 'otc_feature'
    },
    {
      icon: 'task',
      route: '/lab-manager/submissions',
      label: 'LAB-MANAGER',
      roles: ['LabManagerRepresentative', 'LabManagerAgent'],
      relatedRoutes: ['lab-manager'],
      featureFlag: 'lab_feature'
    },
    {
      icon: 'contract_edit',
      route: '/recommendation-manager/recommendations',
      label: 'RECOMMENDATION-MANAGER',
      roles: ['RecommendationManager'],
      relatedRoutes: ['recommendation-manager'],
      isImg: true,
      featureFlag: 'recommendation_feature'
    },
    {
      icon: 'soil-iq-black',
      label: 'SOIL-IQ',
      roles: ['SoilIQ'],
      route: '',
      redirect: 'soil_iq',
      isButton: true,
      isImg: true,
      imgExt: 'png',
      featureFlag: true
    },
    {
      icon: 'view_timeline',
      label: 'OPERATIONAL-PORTAL',
      roles: ['OperationalPortal'],
      route: '',
      redirect: 'operational_portal',
      isButton: true,
      isNew: true,
      // Gated on config rather than Unleash, and on the role.
      //
      // operationalUrl is empty for AllFarm and Southern Gateway, so the item is
      // absent from those builds entirely. Precision Gateway is the whitelabel
      // parent and the only host for the portal, and this makes that structural
      // rather than leaving it to the role check alone.
      featureFlag: !!environment.operationalUrl
    }
  ];

  constructor(
      protected router: Router,
      private featureFlagsService: FeatureFlagsService,
  ) {
  }

  ngOnInit() {
    // this.featureFlagActive = this.featureFlagsService.isEnabled('recomendations_pg_feature');
    // console.log(this.featureFlagActive, 'this.featureFlagActive');
  }

  emitSideBarChanges(redirectText?: string) {
    this.sideBarClose.emit(this.sideBarOpened);

    if(redirectText) {
      this.redirect.emit(redirectText);
    }
  }

  checkRoles(roles: string[]) {
    if(this.roles?.length > 0) {
      if(roles.length === 0) {
        return true;
      }

      return this.roles.some(r => {
        if(roles.includes(r.name)) {
          return true;
        }});
    }

    return false;
  }

checkFeatureFlag(featureFlag?: string | boolean): boolean {
  // Handle hardcoded boolean values used for core features available to all
  if (typeof featureFlag === 'boolean') {
    return featureFlag;
  }
  // Handle string feature flags - check with Unleash
  if (typeof featureFlag === 'string') {
    // console.log(`Checking feature flag: ${featureFlag}`);
    const result = this.featureFlagsService.isEnabled(featureFlag);
    // console.log(`Feature flag '${featureFlag}' result:`, result);
    return result;
  }
  // No flag provided = always show - just in case
  return true;
}


}
